import { endpoint } from "views/pages/manage/common/constant"
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"

export const getVendorDetailsByBuId= async(buId)=>{
    return await fetchAllPromisedData(`${endpoint.businessAreaVendorDetails.getByBuId}/${buId}`)
}

export const saveVendorDetails= async(payload)=>{
    return await fetchAllPostPromisedData(endpoint.businessAreaVendorDetails.create, payload, 'POST')
}

export const updateVendorDetails= async (payload)=>{
    return await fetchAllPostPromisedData(endpoint.businessAreaVendorDetails.update, payload, 'PUT')
}